import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EventService {

  private subscribers_map: any = {};
  constructor() { }

  public on(event: any, subscriber: any) {
    const subs = this.subscribers_map[event] || [];
    let idx = -1, t;
    for (let i = 0; i < subs.length; i++) {
      t = typeof(subscriber);
      if (typeof(subs[i]) === t) {
        idx = i;
        break;
      }
    }
    if (idx == -1) {
      subs.push(subscriber);
    } else {
      subs[idx] = subscriber;
    }
    this.subscribers_map[event] = subs;
  }

  public off(event: any, subscriber: any) {
    const subs = this.subscribers_map[event] || [];
    let idx = -1, t;
    for (let i = 0; i < subs.length; i++) {
      t = typeof(subscriber);
      if (typeof(subs[i]) === t) {
        idx = i;
        break;
      }
    }
    if (idx > -1) {
      subs.splice(idx, 1);
    }
    this.subscribers_map[event] = subs;
  }

  public emit(event: any, args: any) {
    const subs = this.subscribers_map[event] || [];
    for (let i = 0; i < subs.length; i++) {
      if (subs[i].onAppEvent) {
        subs[i].onAppEvent.apply(subs[i], args);
      }
    }
  }
}